import React from 'react';
import { Box, Grid, List, ListItem, Typography, Button } from '@material-ui/core';
import styles from '../../../../styles/tripschedular.module.scss';
import { getDateinDesiredFormat } from '@jumbo/utils/dateHelper';

export default function RecentSearchCardView({ row, handleApply }) {
  return (
    <Box
      className={styles.loadCardWrapper}
      style={{ paddingBottom: '24px', cursor: 'pointer' }}
      onClick={() => handleApply(row)}>
      <Grid container className={styles.loadCardContentRow}>
        <Grid item xs={12}>
          <Box className={styles.cardWrapper}>
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs={3}>
                <Box className={styles.locationListBlk}>
                  <List className={styles.locationList}>
                    <ListItem>
                      <img src="../../../../../images/origin.svg" alt="Origin" />
                      <Typography variant="p" component="h5">
                        {row.origin.name}
                      </Typography>
                      <Typography variant="p" component="p">
                        {row.start_date ? getDateinDesiredFormat(row.start_date, 'MM/DD/YYYY') : '-'}
                        {/* {
                                    row.distance_origin ?
                                    <React.Fragment>
                                        <span> . </span>
                                        <span>
                                            {Number(row.distance_origin) != '0' ? `${Number(row.distance_origin)}mi` : '-'}
                                        </span>
                                    </React.Fragment>
                                    :
                                    ''
                                } */}
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <img src="../../../../../images/destination.svg" alt="Destination" />
                      <Typography variant="p" component="h5">
                        {row.destination.name ? row.destination.name : 'Anywhere'}
                      </Typography>
                      <Typography variant="p" component="p">
                        {row.end_date ? getDateinDesiredFormat(row.end_date, 'MM/DD/YYYY') : ''}
                        {/* {
                                    row.distance_destination ?
                                    <React.Fragment>
                                        <span> . </span>
                                        <span>
                                            {Number(row.distance_destination) != '0' ? `${Number(row.distance_destination)}mi` : '-'}
                                        </span>
                                    </React.Fragment>
                                    :
                                    ''
                                } */}
                      </Typography>
                    </ListItem>
                  </List>
                </Box>
              </Grid>
              <Grid item xs={7}>
                <Box className={styles.infoList} style={{ padding: '10px 0 0' }}>
                  <Grid container>
                    <Grid item xs={3}>
                      <Typography variant="p" component="h6" className={styles.label}>
                        Load Type
                      </Typography>
                      <Typography variant="p" component="p" className={styles.value}>
                        {row.type}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography variant="p" component="h6" className={styles.label}>
                        DH-O
                      </Typography>
                      <Typography variant="p" component="p" className={styles.value}>
                        {Number(row.distance_origin) != '0' ? `${Number(row.distance_origin)}mi` : '-'}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography variant="p" component="h6" className={styles.label}>
                        DH-D
                      </Typography>
                      <Typography variant="p" component="p" className={styles.value}>
                        {Number(row.distance_destination) != '0' ? `${Number(row.distance_destination)}mi` : '-'}
                      </Typography>
                    </Grid>
                    <Grid item xs={3} className={styles.lastColumn}>
                      <Typography variant="p" component="h6" className={styles.label}>
                        Length
                      </Typography>
                      <Typography variant="p" component="p" className={styles.value}>
                        {Number(row.length) || '-'}
                      </Typography>
                    </Grid>
                    <Grid item xs={3} className={styles.lastRow}>
                      <Typography variant="p" component="h6" className={styles.label}>
                        Weight
                      </Typography>
                      <Typography variant="p" component="p" className={styles.value}>
                        {Number(row.weight) || '-'}
                      </Typography>
                    </Grid>
                    <Grid item xs={3} className={styles.lastRow}>
                      <Typography variant="p" component="h6" className={styles.label}>
                        Equipment
                      </Typography>
                      <Typography variant="p" component="p" className={styles.value}>
                        {row.trailer_type || '-'}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Button
                  variant="outlined"
                  color="primary"
                  size="large"
                  style={{ textTransform: 'capitalize' }}
                  onClick={() => {
                    handleApply(row);
                  }}
                  className={styles.bookBtn}>
                  Find Loads
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
